import { render, staticRenderFns } from "./exhibitor-configuration.vue?vue&type=template&id=6c129f7a&scoped=true&"
import script from "./exhibitor-configuration.vue?vue&type=script&lang=js&"
export * from "./exhibitor-configuration.vue?vue&type=script&lang=js&"
import style0 from "./exhibitor-configuration.vue?vue&type=style&index=0&id=6c129f7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c129f7a",
  null
  
)

export default component.exports